<table class="table table-hover" *ngIf="aditivos; else carregando">
  <thead>
    <tr>
      <th scope="col">Id. aditivo</th>
      <th scope="col">Data de formalização</th>
      <th scope="col">Data do protocolo</th>
      <th scope="col">% Desconto ECG <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="% de desconto aplicável para redução do valor do encargo conforme legislação vigente ou pessoa com deficiência"></i></th>
      <th scope="col">ECG complementar</th>
      <th scope="col">Estado</th>
      <th scope="col">Motivo</th>
    <tr>
  </thead>
  <tbody>
    <tr *ngFor="let aditivo of aditivos; let i = index">
      <td><a (click)="visualizarAditivo(aditivo.id)" href="javascript:void(0)">{{ aditivo?.id }}</a></td>
      <td>{{ aditivo?.dataCelebracaoAditivo | date:'dd/MM/yyyy'}}</td>
      <td>{{ aditivo?.dataProtocoloAditivo | date:'dd/MM/yyyy'}}</td>
      <td>{{ aditivo?.valorRedutorEcgComplementar | percent: '2.2-4' }}</td>
      <td>{{ aditivo?.valorEcgComplementar | bnMask: 'MOEDA' }}</td>
      <td>{{ aditivo?.detalhe?.estado?.nomeEstado}}</td>
      <td>{{ aditivo?.detalhe?.estado?.motivoEstado}}</td>
    </tr>
  </tbody>
</table>

<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>